import React from "react"
import {IconButton, Menu, MenuItem, Grid, Tooltip} from "@mui/material"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import InfoIcon from "@mui/icons-material/Info"

const ITEM_HEIGHT = 48

interface MoreDropdownProps {
	options: Array<DropAction>
}

export interface DropAction {
	title: string
	exe: () => void
	trackToolTipClick?: () => void
	icon?: () => void
	disabled?: boolean
	hint?: string
}

export default function MoreDropdown(props: MoreDropdownProps) {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
	const open = Boolean(anchorEl)

	function handleClick(event: React.MouseEvent<HTMLElement>) {
		setAnchorEl(event.currentTarget)
	}

	function handleClose() {
		setAnchorEl(null)
	}

	function handleSelect(action: () => void) {
		handleClose()
		action()
	}

	return (
		<div>
			<IconButton
				aria-label="More"
				aria-owns={open ? "long-menu" : undefined}
				aria-haspopup="true"
				onClick={handleClick}
			>
				<MoreVertIcon />
			</IconButton>
			<Menu
				id="long-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				PaperProps={{
					style: {
						maxHeight: ITEM_HEIGHT * 6.5,
					},
				}}
			>
				{props.options.map((option) => (
					<Grid container direction={"row"} style={{height: "35px"}}>
						<Grid item>
							<MenuItem
								key={option.title}
								onClick={() => handleSelect(option.exe)}
								disabled={option.disabled ? option.disabled : false}
							>
								<>
									{option.icon && option.icon()}
									{option.title}
								</>
							</MenuItem>
						</Grid>
						{option.hint && (
							<Grid item>
								<Tooltip
									title={option.hint ? option.hint : ""}
									disableHoverListener={false}
									onTouchStart={() => option.trackToolTipClick}
								>
									<IconButton aria-label="info">
										<InfoIcon />
									</IconButton>
								</Tooltip>
							</Grid>
						)}
					</Grid>
				))}
			</Menu>
		</div>
	)
}
